function GamePage() {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">New Game</h1>
      <div className="card">
        <p className="text-gray-600">Game creation coming soon...</p>
      </div>
    </div>
  )
}

export default GamePage